import { makeObservable, observable, action, runInAction } from "mobx";

import { LabelValue } from "../models/Dashboard/Analytics";
import QCAnalyticsDashboardAPI from "../api/QCAnalyticsDashboardAPI";
import { QCAnalyticsAPIFilters } from "../models/Dashboard/QCDashboard/QCAnalyticsFilters";

export class QCAnalyticsDashboardStore {
  analyticsAPI: QCAnalyticsDashboardAPI;
  basic_tats: LabelValue[];
  print_basic_tats: LabelValue[];

  constructor() {
    this.analyticsAPI = new QCAnalyticsDashboardAPI();
    this.basic_tats = [];
    this.print_basic_tats = [];

    makeObservable(this, {
      basic_tats: observable,
      print_basic_tats: observable,
      getQCAnalyticsTats: action,
      getQCAnalyticsPrintTats: action,
    });
  }

  getQCAnalyticsTats = async (filters: QCAnalyticsAPIFilters) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "/tats",
        filters
      )) as LabelValue[];
      this.basic_tats = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };

  getQCAnalyticsPrintTats = async (filters: QCAnalyticsAPIFilters) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "/tats/print",
        filters
      )) as LabelValue[];
      this.print_basic_tats = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };
}
